// @ts-expect-error module not typed
import PrimaryMessageContentSection from '../../primary-message/components/PrimaryMessageContentSection';
// @ts-expect-error module not typed
import ContentText from '../../primary-message/ContentText';
import InlineAttachments from '../../attachments/InlineAttachments';
import AttachmentsFooter from '../../attachments/AttachmentsFooter';
import { getFilteredAttachments, hasRenderableAttachments
// @ts-expect-error module not typed
} from 'conversations-message-history/attachments/operators/imageAttachmentFilters';
import { getFileId, getText } from 'conversations-message-history/common-message-format/operators/messageHeaderAttachmentGetters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WorkflowGeneratedUserHeaderAttachment = ({
  headerAttachment,
  fileAttachments,
  genericChannelId
}) => {
  const text = getText(headerAttachment);
  const hasText = text && text.length > 0;
  const hasFileAttachment = getFileId(headerAttachment);
  if (!hasText && !hasFileAttachment) {
    return null;
  }
  const shouldRenderInlineAttachments = hasRenderableAttachments(fileAttachments);
  const renderableAttachments = shouldRenderInlineAttachments && getFilteredAttachments({
    fileAttachments,
    canRender: true
  });
  const nonRenderableAttachments = getFilteredAttachments({
    fileAttachments,
    canRender: false
  });
  const shouldRenderNonInlineAttachments = nonRenderableAttachments && nonRenderableAttachments.size > 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [shouldRenderNonInlineAttachments && /*#__PURE__*/_jsx(AttachmentsFooter, {
      fileAttachments: nonRenderableAttachments,
      genericChannelId: genericChannelId
    }), /*#__PURE__*/_jsxs(PrimaryMessageContentSection, {
      canExpand: false,
      isLastMessage: true,
      children: [shouldRenderInlineAttachments && /*#__PURE__*/_jsx(InlineAttachments, {
        fileAttachments: renderableAttachments,
        genericChannelId: genericChannelId
      }), /*#__PURE__*/_jsx(ContentText, {
        contentText: getText(headerAttachment) || '',
        isPlainText: true
      })]
    })]
  });
};
WorkflowGeneratedUserHeaderAttachment.displayName = 'WorkflowGeneratedUserHeaderAttachment';
export default WorkflowGeneratedUserHeaderAttachment;